import React from 'react';
import { Text, useIsMobile } from '@amzn/storm-ui';
import { BANNER_TYPE, LocalNotification } from '@amzn/aac-chrome-internal-api';
import { bannerIconMap } from 'src/features/header/components/Banners/types';
import {
  BannerIcon,
  ModalBannerListItem,
  ModalBannerListItemContent,
} from './styles';
import { ConnectedBannerContent } from './BannerContent';
import { BANNER_LEVEL } from 'src/app/slice';

interface ConsolidatedBannerModalItemsProps {
  banners: LocalNotification[];
  isConsoleLevel?: boolean;
  bannerLevel: BANNER_LEVEL;
}

export const ConsolidatedBannerModalItems: React.VFC<
  ConsolidatedBannerModalItemsProps
> = ({ banners, bannerLevel }) => {
  const isMobile = useIsMobile();

  return (
    <>
      {banners.map((banner) => {
        // Icon needs to be vertically centered only when at least one of three props is undefined. On mobile devices we always top align the icon
        const isIconVerticallyCentered: boolean =
          (!banner.title || !banner.message || !banner.link) && !isMobile;
        const bannerType = banner.type.toLowerCase();

        return (
          <ModalBannerListItem key={banner.id}>
            <BannerIcon
              type={bannerIconMap[bannerType as BANNER_TYPE]}
              size="large"
              variant={bannerType as BANNER_TYPE}
              isVerticallyCentered={isIconVerticallyCentered}
            />
            <ModalBannerListItemContent>
              <Text inline>
                <ConnectedBannerContent
                  banner={banner}
                  bannerLevel={bannerLevel}
                />
              </Text>
            </ModalBannerListItemContent>
          </ModalBannerListItem>
        );
      })}
    </>
  );
};

ConsolidatedBannerModalItems.defaultProps = {
  isConsoleLevel: false,
};
